import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Highcharts from 'highcharts';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { format } from 'url';
import { ViewmodalReportComponent } from '../viewmodal-report/viewmodal-report.component';
import {monthmaps,tabledataforstates,dataSubs} from 'src/assets/i18n/hi.json'

@Component({
  selector: 'app-admin-dgcreports',
  templateUrl: './admin-dgcreports.component.html',
  styleUrls: ['./admin-dgcreports.component.css']
})
export class AdminDgcreportsComponent implements OnInit {
  yearDropDownList: any;
  dgcGraphFilter: object = {'ay':"",'lu':"","month":""};
  statelists: any[];
  monthsList:any = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
  ];
  chartData: any;
  showTwoCharts: boolean;
  lineChartData: any;
  singleColchartData: any;
  modalRef: any;
  @ViewChild('viewModal',{})viewModal;
  dgcNamesList: any;
  @Input() selectedlanguage:string;
  enableNgOnChanges: boolean;

  constructor(
    private submitdataSerivce : SubmitdataService,
    private constants : ConstantsModule,
    private modalService: NgbModal,  ) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.getdynamicYears();
    this.getstateslist();
    this.setCurrentMonthDefault();
    this.getGraphData();
  }

  ngOnChanges(){
    if(this.enableNgOnChanges){
      this.formatDataForCharts();
    }
  }

  getdynamicYears(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    });
    this.dgcGraphFilter['ay'] = dropDownYear;  
  }

  getstateslist(){
    let postdata = {};
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataSerivce.getLocationList(postdata).subscribe(data =>{
      if(data){
         this.statelists = [];
         Object.keys(data).forEach(key =>{
          data[key].forEach(statelist => {
            this.statelists.push(statelist);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
          });
        })
      }
    });
    this.dgcGraphFilter['lu'] = 'All';
  }

  setCurrentMonthDefault(){
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(monthObj['key']  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.dgcGraphFilter['month'] = currentmonthObj['key'];    
  }

  getGraphData(){
    this.showTwoCharts = false;
    let postdata = {};
    postdata['ay'] = this.dgcGraphFilter['ay'];
    postdata['lu'] = this.dgcGraphFilter['lu'];
    postdata['subTp'] = ["04","05","06","07","08","09","10","11","12","01","02","03"];
    if(this.dgcGraphFilter['lu'] == 'All'){
      postdata['lu'] = "f78f615d-e270-4f93-90ac-27608e756b85"; //ganga basin uuid
      // postdata['subTp'] = [this.dgcGraphFilter['month']];
      this.showTwoCharts = true;
    }
    
    this.submitdataSerivce.dataforReportChart(postdata).subscribe(data =>{
      this.chartData = [];   
      this.chartData = data['data'];
      this.formatDataForCharts();
      this.enableNgOnChanges = true;
    })    
  }

  formatDataForCharts(){
    let data = this.chartData;
    let subData = [];
    let nonSubData = [];
    this.lineChartData = [];

    if (this.showTwoCharts) {
      Object.keys(data).forEach(obj => {
        if (this.formatMonth(obj) == this.dgcGraphFilter['month']) {
          Object.keys(data[obj]).forEach(state => {
            let subValue = parseInt(data[obj][state]['submitted count'][0]);
            let nonSubValue = parseInt(data[obj][state]['pending count'][0]);
            let item1 = {
              'name' : this.selectedlanguage == 'en'? state : tabledataforstates[state],
              'y' : subValue,
              'DGCsList' : data[obj][state]['submitted'],
              'type' : 'submitted'
            };
            let item2 = {
              'name' : this.selectedlanguage == 'en'? state : tabledataforstates[state],
              'y' : nonSubValue,
              'DGCsList' : data[obj][state]['pending'],
              'type' : 'not submitted'
            };
            
            // subData.push([state, subValue,]);
            // nonSubData.push([state, nonSubValue,]);
            subData.push(item1);
            nonSubData.push(item2);
          })
        }
      })
      this.createDoubleColmnChart(subData, nonSubData);

      // Below code for formatting data for Line Chart 
      for (let i = 0; i < this.statelists.length; i++) {
        let arr = [];
        Object.values(data).forEach(month => {
          let subVal = parseInt(month[this.titleCase(this.statelists[i]['name'])]['submitted count'][0])
          // arr.push(subVal);
          if(subVal != 0){
            arr.push(subVal);
          }
        })
        this.lineChartData.push(arr);
      }

      this.createLineChart(this.lineChartData);

    } else {
      // let val = 0;
      this.singleColchartData = [];
      Object.values(data).forEach(mon => {
        Object.values(mon).forEach(state => {
          let percentage = state['percentage'][0];
          let value = parseInt(state['submitted count'][0]);
          let obj = {
            y: null,
            color: null
          }
          let colorvalues;
          if (percentage < 50) {
            colorvalues = '#db7979';
          } else if (percentage >= 50 && percentage < 100) {
            colorvalues = 'yellow';
          } else if (percentage == 100) {
            colorvalues = 'green';
          } else {
            colorvalues = 'black';
          }

          obj['y'] = value;
          obj['color'] = colorvalues
          this.singleColchartData.push(obj)
          // val++;
        })
      })

      this.createSingleColmnChart(this.singleColchartData);
    }
  }

  formatMonth(key){
    let monthKey = key.substring(1,3);
    return monthKey;
  }

  getMonthName(num){
    let date = new Date();
    date.setMonth(num - 1);
    return date.toLocaleString('en-US', { month: 'long' });
  }

  getStateName(stId){
    let stateName;
    this.statelists.forEach(state =>{
      if(state['uuid'] == stId){
        stateName = state['name'];
      }
    })
    return stateName;
  }

  createDoubleColmnChart(subData,nonSubData){   
    let chartTitleEn = "State wise MoMs status for " + this.getMonthName(this.dgcGraphFilter['month']) + " " + this.dgcGraphFilter['ay'];
    let chartTitleHi = "के लिए राज्यवार एमओएम की स्थिति " + monthmaps[this.getMonthName(this.dgcGraphFilter['month'])] + " " + this.dgcGraphFilter['ay'];
    Highcharts.chart('double-column-chart', {
      chart:{
        type: 'column'
      },
      title: {
        text: this.selectedlanguage == 'en'? chartTitleEn : chartTitleHi
      },
      xAxis:{
        // categories: ['Bihar','West Bengal','Uttarakhand','Jharkhand','Uttar Pradesh'],
        type: 'category',
        title: {
          text: this.selectedlanguage == 'en'? 'States' : 'राज्य',
          style: {
            fontSize: '20px',
            color: 'black'
          }          
        },
        labels: {
          style: {
            color: 'black'
          }
        }
      },
      yAxis: {
        title: {
          text: this.selectedlanguage == 'en'? 'No. of DGCs' : 'डीजीसी की संख्या',
          style: {
            fontSize: '15px',
            color: 'black'
          }
        },
        labels: {
          style: {
          color: 'black'
          }
        }
      },
      tooltip: {
        headerFormat: `<div>{point.key}</div><br>`,
        pointFormat: `<div>{series.name} <b>{point.y}</b></div>`,
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions:{
        column: {
          point: {
            events: {
              click: (e) =>{
                this.openDGCsListWindow(e.point.options);
              }
            }
          }
        }
      },
      series: [{
        name: this.selectedlanguage == 'en'? 'Submitted' : 'प्रस्तुत',
        data: subData,
        color: 'green',
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
    {
      name: this.selectedlanguage == 'en'? 'Not submitted' : 'प्रस्तुत नही किया है',
      data: nonSubData,
      color: '#db7979',
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '13px',            
          fontFamily: 'Verdana, sans-serif'
        }
      }
    }]
    } as any);
  }

  createLineChart(data){
    let chartTitleEn = "Month wise status of all States for Assessment year " + this.dgcGraphFilter['ay'];
    let chartTitleHi = "निर्धारण वर्ष के लिए सभी राज्यों की माहवार स्थिति " + this.dgcGraphFilter['ay'];
    let xaxislablesEn = ['April','May','June','July','August','September','October','November','December','January','February','March'];
    let xaxislablesHi = ['अप्रैल','मई','जून','जुलाई','अगस्त','सितम्बर','अक्टूबर','नवंबर','दिसंबर','जनुअरी','फेब्रुअरी','मार्च'];
    Highcharts.chart('line-chart', {
      chart:{
        type: 'line'
      },
      title: {
        text: this.selectedlanguage == 'en'? chartTitleEn : chartTitleHi
      },
      xAxis:{
         categories: this.selectedlanguage == 'en' ? xaxislablesEn : xaxislablesHi,
        // type: 'category',
        title: {
          text: this.selectedlanguage == 'en'? 'Months':dataSubs.months,
          style: {
            fontSize: '20px',
            color: 'black'
          }          
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '15px'
          }
        },
        min: 0,
        max: 11
      },
      yAxis: {
        title: {
          text: this.selectedlanguage == 'en'? 'No. of DGCs submitted' : 'जमा किए गए डीजीसी की संख्या',
          style: {
            fontSize: '18px',
            color: 'black'
          }
        },
        labels: {
          style: {
          color: 'black',
          fontSize: '14px'
         }
        }
      },
      tooltip: {
        enabled:true,
        headerFormat: `<div>{point.key}</div><br>`,
        pointFormat: `<div>{series.name} <b>{point.y}</b></div>`,
        // shared: true,
        split: true
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      // plotOptions:{
      // },
      series: [{
        name: this.selectedlanguage == 'en'? 'Bihar' : tabledataforstates['Bihar'],
        data: data[0],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      {
        name: this.selectedlanguage == 'en'? 'Jharkhand' : tabledataforstates['Jharkhand'],
        data: data[1],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      {
        name: this.selectedlanguage == 'en'? 'Uttar Pradesh' : tabledataforstates['Uttar Pradesh'],
        data: data[2],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      {
        name: this.selectedlanguage == 'en'? 'Uttarakhand' : tabledataforstates['Uttarakhand'],
        data: data[3],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      {
        name: this.selectedlanguage == 'en'? 'West Bengal' : tabledataforstates['West Bengal'],
        data: data[4],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      }]
    } as any);
  }

  createSingleColmnChart(data){  
    let chartTitleEn = "MoMs status for Assessment year " + this.dgcGraphFilter['ay'] + " - " + this.titleCase(this.getStateName(this.dgcGraphFilter['lu'])) + " State";
    let chartTitleHi = "आकलन वर्ष के लिए एमओएम की स्थिति " + this.dgcGraphFilter['ay'] + " - " + tabledataforstates[this.getStateName(this.dgcGraphFilter['lu'])] + " राज्य";
    let xaxislablesEn = ['April','May','June','July','August','September','October','November','December','January','February','March'];
    let xaxislablesHi = ['अप्रैल','मई','जून','जुलाई','अगस्त','सितम्बर','अक्टूबर','नवंबर','दिसंबर','जनुअरी','फेब्रुअरी','मार्च'];
    Highcharts.chart('single-column-chart', {
      chart:{
        type: 'column'
      },
      title: {
        text: this.selectedlanguage == 'en'? chartTitleEn : chartTitleHi
      },
      xAxis:{
        categories: this.selectedlanguage == 'en' ? xaxislablesEn : xaxislablesHi,
        // type: 'category',
        title: {
          text: this.selectedlanguage == 'en'? 'Months':dataSubs.months,
          style: {
            fontSize: '20px',
            color: 'black'
          }          
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '15px'
          }
        }
      },
      yAxis: {
        title: {
          text: this.selectedlanguage == 'en'? 'No. of DGCs submitted' : 'जमा किए गए डीजीसी की संख्या',
          style: {
            fontSize: '18px',
            color: 'black'
          }
        },
        labels: {
          style: {
          color: 'black',
          fontSize: '14px'
          }
        }
      },
      tooltip: {
        headerFormat: `<div>{point.key}</div><br>`, 
        pointFormat: this.selectedlanguage == 'en'?`<div>No. of DGCs submitted: <b>{point.y}</b></div>`: `<div>जमा किए गए डीजीसी की संख्या: <b>{point.y}</b></div>`
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: true,
        useHTML:true,
        labelFormatter: this.selectedlanguage == 'en'? function() {
          let legendGreenEn = '<div>' +
          '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "green" +'; display: inline-block; margin-right:5px"></div>' +
          "<span>" + "Meeting > 99%" + "&nbsp&nbsp&nbsp" + "</span>" +
          '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "yellow" +'; display: inline-block; margin-right:5px"></div>' +
          "<span>" + "Meeting 50% to 99%" + "&nbsp&nbsp&nbsp" + "</span>" +
          '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "#db7979" +'; display: inline-block; margin-right:5px"></div>' +
          "<span>" + "Meeting 0% to 49.99%" + "</span>" +
      '</div>'
          // '<div><div style="border-radius: 50%; width: 10px; height: 10px; background-color: "green"; display: inline-block; margin-right:5px"> </div>' + '<span class="symbol" style="background-color: green; width: 13px; height: 13px;"></span>' + ' meeting 99%' + '</div>' 
          // +'<div style="border-radius: 50%; width: 10px; height: 10px; background-color:"yellow"; display: inline-block; margin-right:5px"> </div>' + '<span class="symbol" style="background-color: green; width: 13px; height: 13px;"></span>' + ' meeting 59%' + '</div></div>';
          return legendGreenEn } : function() {
            let legendGreenHi = '<div>' +
            '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "green" +'; display: inline-block; margin-right:5px"></div>' +
            "<span>" + "बैठक > 99%" + "&nbsp&nbsp&nbsp" + "</span>" +
            '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "yellow" +'; display: inline-block; margin-right:5px"></div>' +
            "<span>" + "बैठक 50% to 99%" + "&nbsp&nbsp&nbsp" + "</span>" +
            '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "#db7979" +'; display: inline-block; margin-right:5px"></div>' +
            "<span>" + "बैठक 0% to 49.99%" + "</span>" +
        '</div>'
            // '<div><div style="border-radius: 50%; width: 10px; height: 10px; background-color: "green"; display: inline-block; margin-right:5px"> </div>' + '<span class="symbol" style="background-color: green; width: 13px; height: 13px;"></span>' + ' meeting 99%' + '</div>' 
            // +'<div style="border-radius: 50%; width: 10px; height: 10px; background-color:"yellow"; display: inline-block; margin-right:5px"> </div>' + '<span class="symbol" style="background-color: green; width: 13px; height: 13px;"></span>' + ' meeting 59%' + '</div></div>';
            return legendGreenHi },
          symbolHeight: '0px'
      },
      plotOptions:{
        series: {
          events: {
            legendItemClick: function(){
              return false
            }
          }
        }
      },
      exporting : {
        allowHTML: true
      },
      series: [{
        data: data,
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      }]
    } as any);
  }

  openDGCsListWindow(data){
    this.dgcNamesList = data;
    this.modalRef = this.modalService.open(this.viewModal,{backdrop: 'static',windowClass: 'backgroundTransparent dgc-list'});    
  }

  CloseVideoModal(){
    this.modalRef.dismiss(this.viewModal)
  }

  titleCase(str){    
    str = str.toLowerCase().split(' ');
    for(var i = 0; i < str.length; i++){
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

}


